module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 547
// module chunks = 23